import {Toast,Button,Dialog} from 'vant';
import Cloading from '@/components/Cloading.vue'
export default function loadComponents(app:any){
    app.use(Toast);
    app.use(Button);
    app.use(Dialog)
    app.component('c-loading', Cloading)
    return app;
}